<template>
    <div class="modal-bg" v-show="show" @mousemove="modalMove" @mouseup="cancelMove">
        <div class="modal-container">
            <div class="modal-header" @mousedown="setStartingPoint">
                {{ title }}
                <button type="primary" round @click="LastPage">前页</button> 
                <button type="primary" round @click="NextPage">后页</button>
           </div>
            <div class="modal-main">
                <slot></slot>
            </div>
            <div class="modal-footer">
                <el-button type="primary" round @click="hideModal">取消</el-button> 
                <el-button type="primary" round @click="submit" v-if="enableButton">确认</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'modal',
    props: {
	    enableButton: {
            type: Boolean,
            default: false
		},
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        NodeInform_1: {
            type: String,
            default: '1'
        },
        NodeInform_2: {
            type: String,
            default: '2'
        },
        NodeInform_3: {
            type: String,
            default: '3'
        },
        NodeInform_4: {
            type: String,
            default: '4'
        },
        NodeInform_5: {
            type: String,
            default: '5'
        },
        NodeInform_6: {
            type: String,
            default: '6'
        },
        NodeInform_7: {
            type: String,
            default: '7'
        },
        NodeInform_8: {
            type: String,
            default: '8'
        },
        NodeInform_9: {
            type: String,
            default: '9'
        },
        NodeInform_10: {
            type: String,
            default: '10'
        },
		
    },
    data() {
        return {
            x: 0,
            y: 0,
            node: null,
            isCanMove: true
        }
    },
    mounted() {
        this.node = document.querySelector('.modal-container')
    },
    methods: {
        LastPage() {
            this.$emit('LastPage')
        },
		
        NextPage() {
            this.$emit('NextPage')
        },
		
        hideModal() {
            this.$emit('hideModal')
        },

        submit() {
            this.$emit('submit')
        },

        setStartingPoint(e) {
            this.x = e.clientX - this.node.offsetLeft
            this.y = e.clientY - this.node.offsetTop
            this.isCanMove = true
        },

        modalMove(e) {
            if (this.isCanMove) {
                this.node.style.left = e.clientX - this.x + 'px'
                this.node.style.top = e.clientY - this.y + 'px'
            } 
        },

        cancelMove() {
            this.isCanMove = false
        }
    }
}
</script>

<style scoped>
.modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.2);
    z-index: 10;
}
.modal-container {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.modal-header {
    height: 56px;
    background: #409EFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
}
.modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 57px;
    border-top: 1px solid #ddd;
}
.modal-footer button {
    width: 80px;
}
.modal-main {
    padding: 15px 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue